export const initialState = {
  options: []
}

export const productOptionReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_OPTION':
      return {
        ...state,
        options: state.options.concat([action.value])
      }
    case 'DELETE_OPTION':
      return {
        ...state,
        options: state.options.filter((option) => option.option_id !== action.value)
      }
    case 'CHANGE_OPTION':
      return {
        ...state,
        options: state.options.map((item) => {
          if (item.option_id === action.value.option_id) {
            return { ...action.value };
          }
          
          return { ...item };
        })
      }
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
}